import { css } from "@emotion/react";

import { colors, dimensions, layers } from "@styles";

const navHeight = "4.75rem";

export const mainNav = css`
  width: 100%;
  height: ${navHeight};
  background-color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: ${layers.indexPageHeader};
  box-shadow: 0 2px 5px rgb(0 0 0 / 15%);

  @media only screen and (max-width: ${dimensions.tabletMax}) {
  }
`;

export const container = css`
  display: flex;
  height: 100%;
  justify-content: center;

  &&& {
    margin: 0 2rem;
    max-width: 100%;
  }
`;
